module.exports = __webpack_public_path__ + "img/green_circle_36.0e0bd96a.svg";